<script>
import ResourceProgress from "@/components/modals/resource-progress.vue";
export default {
    name: "ApiResourceLogs",
    data() {
        return {
            tableBusy: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "dateWTime",
            sortDesc: false,
            fields: [
                {
                    key: "dateWTime",
                    sortable: true,
                    label: "Date",
                    thStyle: { width: "250px" },
                },
                {
                    key: "applicationUser.completeName",
                    sortable: true,
                    label: "User",
                    thStyle: { width: "350px" },
                },
                {
                    key: "remarks",
                    sortable: true,
                },
            ],
        };
    },
    
    components: {
        ResourceProgress
    },
    computed: {
        rows() {
            return this.tableData.length;
        },
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        hideModal() {
            this.$bvModal.hide("api-resoure-log-modal");
        },
        async getData(id) {
            this.$nextTick(async () => {
                this.tableBusy = true;
                await this.wait(500)
                await this.$refs.rpModal.getData(id);
                this.$store
                    .dispatch("apiresourecelog/GetApiResourceLogs", id)
                    .then((res) => {
                        res.data.forEach((item) => {
                            item.dateWTime = this.formatDateWithTime(
                                new Date(item.logDate)
                            );
                            item.splitted = item.dateWTime.split(" at ");
                        });
                        this.tableData = res.data;
                        this.tableBusy = false;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            });
        },
    },
};
</script>

<template>
    <b-modal
        id="api-resoure-log-modal"
        title="API Resource Logs"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <resource-progress ref="rpModal"></resource-progress>
        <h3 class="text-center">Resource Logs</h3>
        
        <div class="d-flex justify-content-center mt-4 mx-5 px-5 mb-4">
            <ul class="verti-timeline list-unstyled">
                <template v-if="tableBusy">
                    <li class="event-list" v-for="n in 5" :key="n">
                        <div class="event-timeline-dot">
                            <i class="bx bx-right-arrow-circle font-size-18"></i>
                        </div>
                        <div class="media">
                            <div class="d-flex flex-column">
                                <b-skeleton width="100px" height="15px" class="bg-primary bg-soft"></b-skeleton>
                                <b-skeleton width="50px" height="10px" class="bg-primary bg-soft"></b-skeleton>
                            </div>
                            <i
                                class="
                                    bx bx-right-arrow-alt
                                    font-size-16
                                    text-primary
                                    align-middle
                                    ms-2
                                "
                            ></i>
                            <div class="media-body">
                                <b-skeleton width="450px" height="15px" class="bg-primary bg-soft ms-3"></b-skeleton>
                            </div>
                        </div>
                    </li>
                </template>
                <template v-else>
                    <li class="event-list" v-for="(x, xIndex) in tableData" :key="x.id" :class="{'active': xIndex == 0}">
                        <div class="event-timeline-dot">
                            <i class="bx bx-right-arrow-circle font-size-18" :class="{'bx-fade-right': xIndex == 0}"></i>
                        </div>
                        <div class="media">
                            <div class="me-3">
                                <h5 class="font-size-14 mb-0">
                                    {{x.splitted[0]}}
                                    <i
                                        class="
                                            bx bx-right-arrow-alt
                                            font-size-16
                                            text-primary
                                            align-middle
                                            ms-2
                                        "
                                    ></i>
                                </h5>
                                <small>{{x.splitted[1]}}</small>
                            </div>
                            <div class="media-body">
                                <div class="mb-0" style="line-height:14px;">{{x.remarks}}</div>
                                <div><small>({{x.applicationUser.completeName.trim()}})</small></div>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
        </div>
    </b-modal>
</template>